import React, { useEffect } from 'react';
import FeaturedProducts from '../components/home/FeaturedProducts.tsx';
import SoftSellingCTA from '../components/home/SoftSellingCTA.tsx';
import { useApp } from '../context/AppContext.tsx';

export default function ProductsCatalog() {
  const { settings } = useApp();
  const productSec = settings?.sections?.find((s) => s.type === 'featured_products');
  const pageTitle = productSec?.title || 'Comprehensive B2B Green Services & Solutions Catalog';
  const pageSubtitle = productSec?.subtitle || 'Explore certified ESG consulting, corporate GHG accounting, clean technology implementations, and executive green talent pipelines.';

  useEffect(() => {
    const customTab = settings?.pageTabTitles?.products?.trim();
    if (customTab) {
      document.title = customTab;
    } else {
      const suffix = settings?.pageTabTitles?.titleSuffix !== undefined ? settings.pageTabTitles.titleSuffix : ` | ${settings?.siteName || ''}`;
      document.title = `${pageTitle}${suffix}`;
    }
  }, [pageTitle, settings?.siteName, settings?.pageTabTitles?.products, settings?.pageTabTitles?.titleSuffix]);

  return (
    <div id="products-catalog-page" className="py-6 space-y-6">
      <FeaturedProducts
        badge={productSec?.badge || 'ENTERPRISE SOLUTIONS & SERVICES'}
        title={pageTitle}
        subtitle={pageSubtitle}
        limit={8}
        isPageMode={true}
      />
      <SoftSellingCTA />
    </div>
  );
}
